import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  TextField, Button, IconsPack, Icons,
} from '@pik/pik-ui';

import { send } from '../../services/marketDays/actions';

import S from './styles';

const createContent = (eng) => ({
  title: eng ? 'PIK CMD 2021 Registration' : 'Регистрация на День Рынков Капитала (CMD) ПИК 2021',
  titleSent: eng ? 'Thank you for your registration!' : 'Спасибо за регистрацию!',
  description: eng ? 'PIK is pleased to invite you to its Capital Markets Day. For participation please fill out the information below:' : 'ПИК рад пригласить вас на свой День Рынков Капитала. Для участия, пожалуйста, заполните информацию ниже:',
  descriptionSent: eng ? 'Links and <nobr>dial-in</nobr> numbers will be&nbsp;sent to&nbsp;you via submitted <nobr>e-mail</nobr> prior to&nbsp;the event.' : 'Ссылки и телефонные номера для подключения будут высланы на e-mail, указанный при регистрации за несколько дней до мероприятия.',
  date: eng ? '10th September, 2021' : '10 Сентября 2021 г.',
  time: eng ? '14:00 Moscow time' : '14:00 по МСК',
  button: eng ? 'Submit' : 'Отправить',
  calendar: eng ? 'Add to calendar' : 'Добавить в календарь',
});

const createFields = (eng) => ([
  {
    name: 'firstName',
    type: 'text',
    placeholder: eng ? 'First name' : 'Имя',
    required: true,
    isValidate: true,
  },
  {
    name: 'lastName',
    type: 'text',
    placeholder: eng ? 'Last name' : 'Фамилия',
    required: true,
    isValidate: true,
  },
  {
    name: 'company',
    type: 'text',
    placeholder: eng ? 'Company' : 'Компания',
    description: eng ? 'If you are private investor please enter: « — »' : 'Если вы частный инвестор, поставьте "-" в графе',
    required: true,
    isValidate: true,
  },
  {
    name: 'email',
    type: 'email',
    placeholder: eng ? 'E-mail' : 'E-mail',
    required: true,
  },
  {
    name: 'phone',
    type: 'number',
    placeholder: eng ? 'Phone (Optional)' : 'Тел (по желанию)',
  },
]);

class MarketDays extends PureComponent {
  state = {
    data: null,
    validate: null,
    disableButton: true,
  };

  componentDidMount() {
    this.createInitState();
  }

  createInitState = () => {
    const { lang } = this.props;
    const eng = lang && lang === 'eng';
    const data = {};
    const validate = {};
    const fields = createFields(eng);

    fields.forEach(({ name, required }) => {
      data[name] = '';
      if (required) validate[name] = false;
    });

    return this.setState({ data, validate });
  };

  handleSend = () => {
    const { sendAction } = this.props;
    const { data } = this.state;

    return sendAction(data);
  };

  handleCheck = () => {
    const { validate } = this.state;
    const validateValues = Object.values(validate);
    const disableButton = validateValues.some((val) => !val);

    return this.setState({ disableButton });
  };

  handleChange = (name, value, isValidate) => {
    const { data } = this.state;
    const callBack = isValidate ? this.handleValidate(name, !!value) : null;

    return this.setState({ data: { ...data, [name]: value } }, () => callBack);
  };

  handleValidate = (name, status) => {
    const { validate } = this.state;

    return this.setState({ validate: { ...validate, [name]: status } }, () => this.handleCheck());
  };

  renderField = (field) => {
    const { data } = this.state;
    const {
      name, type, placeholder, description, isValidate,
    } = field;
    const value = data[name];

    return (
      <S.Field>
        <TextField
          name={name}
          value={value}
          type={type}
          placeholder={placeholder}
          inputStyle="accent"
          onChange={(n, v) => this.handleChange(n, v, isValidate)}
          onValidate={this.handleValidate}
        />
        <S.TextFieldDescription dangerouslySetInnerHTML={{ __html: description }} />
      </S.Field>
    );
  };

  renderContent = () => {
    const { sent, loading, lang } = this.props;
    const eng = lang && lang === 'eng';

    const { disableButton } = this.state;
    const fields = createFields(eng);
    const content = createContent(eng);
    const {
      title, titleSent, description, descriptionSent, date, time, button, calendar,
    } = content;

    if (sent) {
      return (
        <S.Sent>
          <S.SentIcon>
            <IconsPack name="checkmark" type="outline" size="xl" />
          </S.SentIcon>
          <S.SentTitle>{titleSent}</S.SentTitle>
          <S.SentDesc dangerouslySetInnerHTML={{ __html: descriptionSent }} />
          <S.Icons sent>
            <S.Icon>
              <Icons type="calendar" />
              <S.IconText>{date}</S.IconText>
            </S.Icon>
            <S.Icon>
              <IconsPack name="time" type="outline" size="l" />
              <S.IconText>{time}</S.IconText>
            </S.Icon>
          </S.Icons>
          <S.SentButton>
            <Button
              text={calendar}
              type="secondary"
              to="//2.db-estate.cdn.pik-service.ru/attachment_pikru/0/c7feeac1-49ac-11eb-913c-0050568dfbb1/ical-20210219-154328_b3b69a57013bb408ac65b75e390fbf97.ics"
              iconNode={
                <Icons type="calendar" size="xs" />
              }
            />
          </S.SentButton>
        </S.Sent>
      );
    }

    return (
      <S.Form>
        <S.Title>{title}</S.Title>
        <S.Descrition>{description}</S.Descrition>
        <S.Icons>
          <S.Icon>
            <Icons type="calendar" />
            <S.IconText>{date}</S.IconText>
          </S.Icon>
          <S.Icon>
            <IconsPack name="time" type="outline" size="l" />
            <S.IconText>{time}</S.IconText>
          </S.Icon>
        </S.Icons>
        <S.Fields>
          { fields.map((field) => this.renderField(field)) }
        </S.Fields>
        <S.Button>
          <Button
            text={button}
            onClick={this.handleSend}
            disabled={disableButton}
            loading={loading}
            size="l"
            fullWidth
          />
        </S.Button>
      </S.Form>
    );
  };

  render() {
    const { sent } = this.props;
    const { data } = this.state;

    if (data) {
      return (
        <S.MarketDays sent={sent}>
          { this.renderContent() }
        </S.MarketDays>
      );
    }

    return null;
  }
}

MarketDays.propTypes = {
  sendAction: PropTypes.func.isRequired,
  sent: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  lang: PropTypes.string.isRequired,
};

const mapStateToProps = ({ marketDaysService: { sent, loading }, appService: { lang } }) => ({
  sent, loading, lang,
});

const mapDispatchToProps = {
  sendAction: send,
};

export default connect(mapStateToProps, mapDispatchToProps)(MarketDays);
